var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAppLoaded && _vm.canStart && _vm.isVisible)?_c('TWebIntegration',{style:(_vm.themeStyles),attrs:{"isAppLoaded":_vm.isAppLoaded}},[_c('router-view')],1):_c('AInitialLoader')}
var staticRenderFns = []

export { render, staticRenderFns }